export default {
  variant: "text.sansMicro02Medium",
  position: "relative",
  width: "fit-content",
  minWidth: "fit-content",
  px: "s100",
  py: "s50",
  borderRadius: "xs",
  display: "inline-block",
  textWrap: "nowrap",
  fontFamily: "textSans",
  transition: "background-color 250ms ease-in-out",
};

export const gold = {
  variant: "badges.default",
  bg: "backgroundBrandDarkStatic",
  color: "textWhiteStatic",
};

export const neutral = {
  variant: "badges.default",
  bg: "backgroundInverse",
  color: "textInverse",
};
